"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Tabs/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Item = require('./Item'); var _Item2 = _interopRequireDefault(_Item);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

















const Tabs = ({
  type, value, options, onSelectTab, className,
}) => {
  const listRef = _react.useRef(null)
  // Left and right arrows move between the tabs and select them.
  const onKeyDown = (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
    const index = options.findIndex(o => o.value === value)
    const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + options.length) % options.length
    event.preventDefault()
    onSelectTab(options[next].value)
    _optionalChain([listRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.querySelectorAll, 'call', _3 => _3('[role="tab"]'), 'access', _4 => _4[next], 'optionalAccess', _5 => _5.focus, 'call', _6 => _6()])
  }
  return (
    _react2.default.createElement('div', { ref: listRef, role: "tablist", onKeyDown: onKeyDown, className: _classBuilder2.default.call(void 0, 
      type === 'filter' ? "filter-tabs--container" : "tabs--container",
      className,
    ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
      ,  options.map(o => (
        _react2.default.createElement(_Item2.default, {
          key: o.value,
          onClick: () => onSelectTab(o.value),
          isSelected: o.value === value,
          iconName: o.iconName,
          label: o.label,
          badge: o.badge,
          className: type === "tabs" ? "tabs--item" : "filter-tabs--item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
        )
      ))
    )
  )
}

exports. default = Tabs
